import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BottomNavigation, BottomNavigationAction } from '@mui/material';
import { Dashboard, MonetizationOn } from '@mui/icons-material';

const BottomNavigationBar = ({ currentPage }) => {
    const navigate = useNavigate();

    const handleNavigation = (event, newPage) => {
        navigate(newPage); // Navigate to the selected page
    };

    const navigations = [
      { label: '首页', path: '/dashboard', icon: Dashboard },
      { label: '抢单', path: '/payout', icon: MonetizationOn },
    ];

    return (
      <BottomNavigation
        showLabels
        value={currentPage}
        onChange={(event, newValue) => handleNavigation(event, newValue)}
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          minHeight: 'calc(56px + env(safe-area-inset-bottom))',
          paddingBottom: 'env(safe-area-inset-bottom)',
          backgroundColor: 'var(--bg-secondary-color)',
          color: '#fff',
        }}
      >
        {
          navigations.map((nav, index) => (
            <BottomNavigationAction
              key={index}
              label={nav.label}
              value={nav.path}
              icon={<nav.icon sx={{ color: currentPage === nav.path ? 'var(--primary-color)' : '#fff' }} />}
              sx={{ color: currentPage === nav.path ? 'var(--primary-color)' : '#fff' }}
            />
          ))
        }
      </BottomNavigation>
  );
};

export default BottomNavigationBar;
